module.exports = __webpack_public_path__ + "static/media/normal1.43ec11c2.svg";